// Full pricing catalog for Stainless Drycleaners (per official rate board).
// Ranged items show as "from ₹X"; single-price items as "₹X".

export const OFFER = {
  headline: "25% off on orders above ₹1,000",
  tiers: [
    { range: "₹1,000 – ₹15,000", pct: "25%", pctNum: 25, min: 1000, max: 15000, label: "Everyday orders" },
    { range: "₹15,001 – ₹35,000", pct: "35%", pctNum: 35, min: 15001, max: 35000, label: "Bulk & seasonal" },
    { range: "₹35,001 – ₹50,000", pct: "50%", pctNum: 50, min: 35001, max: 50000, label: "Whole-home / commercial" },
  ],
  note: "Higher tiers apply to bulk and whole-property jobs. Minimum order ₹500 · free pick & drop across South Delhi.",
};

export const PRICING_CATEGORIES = [
  {
    id: "mens-wear",
    label: "Men's Wear",
    items: [
      { item: "Shirt / T-shirt", variant: "Standard", display: "₹120", popular: true },
      { item: "Trouser / Pants", variant: "Standard", display: "₹120", popular: true },
      { item: "Jeans / Cargo", variant: "Standard", display: "from ₹120", popular: true },
      { item: "Coat / Woollen", variant: "Standard", display: "from ₹250" },
      { item: "Gent's Suit", variant: "2 Piece", display: "₹280", popular: true },
      { item: "Gent's Suit", variant: "3 Piece", display: "₹350" },
      { item: "Designer Suit", variant: "Standard", display: "from ₹380" },
      { item: "Kurta / White Kurta", variant: "Standard", display: "₹180", popular: true },
      { item: "Kurta Fancy", variant: "Standard", display: "from ₹220" },
      { item: "Pajama", variant: "Standard", display: "from ₹120" },
      { item: "Shorts", variant: "Standard", display: "from ₹80" },
      { item: "Safari Suit Set", variant: "Standard", display: "from ₹280" },
      { item: "Waist Coat", variant: "Standard", display: "from ₹180" },
      { item: "Dhoti", variant: "Standard", display: "from ₹180" },
      { item: "Sherwani", variant: "Standard", display: "from ₹350", popular: true },
      { item: "Jacket", variant: "Standard", display: "from ₹350" },
      { item: "Jacket Leather", variant: "Leather", display: "from ₹350", popular: true },
      { item: "Overcoat", variant: "Standard", display: "from ₹350" },
      { item: "Sweater", variant: "Standard", display: "from ₹150" },
      { item: "Sweatshirt", variant: "Standard", display: "from ₹180" },
      { item: "Track Suit Set", variant: "Standard", display: "₹350" },
      { item: "Chef Coat", variant: "Standard", display: "₹350" },
      { item: "Muffler", variant: "Standard", display: "₹100" },
      { item: "Tie", variant: "Standard", display: "from ₹80" },
      { item: "Hat / Cap", variant: "Standard", display: "from ₹150" },
      { item: "Gloves", variant: "Pair", display: "₹150" },
      { item: "Thermals", variant: "Standard", display: "₹80" },
      { item: "Sendo / Vest", variant: "Standard", display: "₹80" },
    ],
  },
  {
    id: "womens-wear",
    label: "Women's Wear",
    items: [
      { item: "Ladies Top", variant: "Standard", display: "from ₹150" },
      { item: "Skirt", variant: "Standard", display: "from ₹180" },
      { item: "Kurta", variant: "Standard", display: "from ₹150", popular: true },
      { item: "Dupatta", variant: "Standard", display: "from ₹120" },
      { item: "Blouse", variant: "Standard", display: "from ₹120" },
      { item: "Salwar / Pajama", variant: "Standard", display: "from ₹120" },
      { item: "Anarkali", variant: "Standard", display: "from ₹350" },
      { item: "Saree", variant: "Standard", display: "from ₹320", popular: true },
      { item: "Zari Saree", variant: "Zari", display: "from ₹350" },
      { item: "Saree Designer", variant: "Designer", display: "₹450", popular: true },
      { item: "Western Dress", variant: "Standard", display: "from ₹350" },
      { item: "Nun's Gown", variant: "Standard", display: "₹500" },
      { item: "Stole / Shawl", variant: "Standard", display: "from ₹320" },
      { item: "Shawl", variant: "Standard", display: "from ₹320" },
      { item: "Jacket", variant: "Standard", display: "from ₹350" },
      { item: "Lehenga", variant: "Light", display: "from ₹350", popular: true },
      { item: "Lehenga", variant: "Medium", display: "from ₹450" },
      { item: "Lehenga", variant: "Heavy", display: "from ₹650" },
      { item: "Lehenga", variant: "Bridal", display: "from ₹1,250", popular: true },
    ],
  },
  {
    id: "shoes",
    label: "Bags, Shoes & Sandals",
    items: [
      { item: "Shoes Sports", variant: "Sports", display: "₹400", popular: true },
      { item: "Shoes Canvas", variant: "Canvas", display: "₹400" },
      { item: "Shoes Leather", variant: "Leather", display: "₹400", popular: true },
      { item: "Shoes Suede", variant: "Suede", display: "₹450" },
      { item: "Shoes Long", variant: "Long boots", display: "₹500" },
      { item: "Ladies Sandal", variant: "Standard", display: "₹400" },
      { item: "Belt", variant: "Standard", display: "₹150" },
      { item: "Purse", variant: "Standard", display: "from ₹450" },
      { item: "Hand Bags", variant: "Standard", display: "from ₹450" },
      { item: "Trolley Bag", variant: "Standard", display: "from ₹500" },
    ],
  },
  {
    id: "household",
    label: "Home & Furnishings",
    items: [
      { item: "Bedsheet", variant: "Single", display: "from ₹150" },
      { item: "Bedsheet", variant: "Double", display: "₹250", popular: true },
      { item: "Bedsheet", variant: "Heavy", display: "from ₹350" },
      { item: "Bed Cover", variant: "Single", display: "₹250" },
      { item: "Bed Cover", variant: "Double", display: "₹350" },
      { item: "Bed Cover", variant: "King Size", display: "₹350" },
      { item: "Blanket", variant: "Single", display: "₹350" },
      { item: "Blanket", variant: "Double", display: "from ₹450", popular: true },
      { item: "Quilt", variant: "Single", display: "₹350" },
      { item: "Quilt", variant: "Double", display: "from ₹450" },
      { item: "Quilt Cover", variant: "Standard", display: "from ₹250" },
      { item: "Sleeping Bags", variant: "Standard", display: "₹850" },
      { item: "Carpet / Dari", variant: "Per sq ft", display: "₹40 / sq ft" },
      { item: "Cushion", variant: "Standard", display: "from ₹180" },
      { item: "Cushion Cover", variant: "Standard", display: "from ₹150" },
      { item: "Curtain (Per Panel)", variant: "Plain", display: "₹280", popular: true },
      { item: "Curtain", variant: "Net", display: "from ₹280" },
      { item: "Curtain", variant: "Lining", display: "from ₹350" },
      { item: "Curtain", variant: "Velvet", display: "from ₹380" },
      { item: "Towel", variant: "Standard", display: "from ₹180" },
      { item: "Table Cover", variant: "Standard", display: "from ₹250" },
    ],
  },
  {
    id: "wedding",
    label: "Wedding & Gowns",
    items: [
      { item: "Wedding Dress", variant: "Standard", display: "₹2,500", popular: true },
      { item: "Christian Gown", variant: "Standard", display: "₹2,500" },
      { item: "Lehenga (Bridal)", variant: "Bridal", display: "from ₹1,250" },
    ],
  },
  {
    id: "soft-toys",
    label: "Soft Toys",
    items: [
      { item: "Soft Toys", variant: "Small – Large", display: "from ₹250", popular: true },
      { item: "Baby Pram", variant: "Standard", display: "₹1,450" },
    ],
  },
  {
    id: "laundry",
    label: "Laundry (per kg)",
    items: [
      { item: "Wash & Fold", variant: "Per kg", display: "₹90 / kg", popular: true },
      { item: "Wash & Iron", variant: "Per kg", display: "₹120 / kg" },
    ],
  },
];
